import { useEffect } from 'react';
import { useUIStore } from '@/store/slices/ui-slice';
import { MOBILE_QUERY } from './use-mobile-viewport';

/**
 * Phones are always dark. The header has no room for the theme switcher there, so it is
 * hidden (`header.css`), and a stored "light" would otherwise be stuck with no way out.
 * The stored preference is left alone and applies again on a wider screen.
 */
const DARK_QUERY = '(prefers-color-scheme: dark)';

export function useTheme() {
  const { theme, setTheme } = useUIStore();

  useEffect(() => {
    const phone = window.matchMedia(MOBILE_QUERY);
    const systemDark = window.matchMedia(DARK_QUERY);

    const apply = () => {
      const resolvedTheme = phone.matches
        ? 'dark'
        : theme === 'system'
          ? (systemDark.matches ? 'dark' : 'light')
          : theme;
      const root = window.document.documentElement;
      root.classList.remove('light', 'dark');
      root.classList.add(resolvedTheme);
      root.dataset.theme = resolvedTheme;
      root.style.colorScheme = resolvedTheme;
    };

    apply();
    phone.addEventListener('change', apply);
    systemDark.addEventListener('change', apply);
    return () => {
      phone.removeEventListener('change', apply);
      systemDark.removeEventListener('change', apply);
    };
  }, [theme]);

  return { theme, setTheme };
}
